import React from 'react';
import { Alert, AlertProps } from 'reactstrap';

const OtoAlert: React.FC<AlertProps> = ({ children, ...rest }) => {
  return <Alert {...rest}>{children}</Alert>;
};

export default OtoAlert;
